/**
 * Web stand-in for `react-native-html-to-pdf`.
 *
 * The real package renders HTML to a PDF file through a native WebView, which
 * a browser does not have. On web the label sheet is printed through
 * react-native-print's shim instead, and the browser's print dialog already
 * offers "Save as PDF" - so this module only has to exist and fail clearly
 * if something still asks it for a file.
 */

export type PDFOptions = {
  html: string;
  fileName?: string;
  directory?: string;
  width?: number;
  height?: number;
  padding?: number;
  bgColor?: string;
  shouldPrintBackgrounds?: boolean;
  base64?: boolean;
};

export type PDFResult = {
  filePath: string;
  base64?: string;
};

export async function generatePDF(_options: PDFOptions): Promise<PDFResult> {
  throw new Error(
    'PDF files cannot be generated in the browser. Use Print and choose "Save as PDF".',
  );
}

export default {generatePDF};
